import { ShieldCheck, MapPin, GitBranch } from "lucide-react";

export default function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* Brand panel */}
      <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12 relative overflow-hidden">
        <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-teal/20 blur-3xl" />
        <div className="flex items-center gap-3 relative z-10">
          <div className="bg-white rounded-xl px-4 py-3 inline-flex shadow-lg">
            <img src="/medoho-logo.png" alt="Medoho — Digital Power for Doctors" className="h-9 w-auto" />
          </div>
        </div>

        <div className="relative z-10 space-y-6 max-w-md">
          <h2 className="text-3xl font-bold leading-tight">The sales operating system for healthcare field teams.</h2>
          <p className="text-slate-300 text-sm leading-relaxed">
            Manage doctor & clinic leads, prevent duplicates, track field work on the map, and move deals through
            your pipeline — all with role-based access and full audit trails.
          </p>
          <div className="space-y-3 pt-2">
            {[
              { icon: ShieldCheck, t: "Secure, role-based access" },
              { icon: GitBranch, t: "14-stage lead & deal pipeline" },
              { icon: MapPin, t: "Live field work tracking" },
            ].map((f, i) => (
              <div key={i} className="flex items-center gap-3 text-sm text-slate-200">
                <div className="grid place-items-center h-8 w-8 rounded-lg bg-white/10"><f.icon className="h-4 w-4 text-teal" /></div>
                {f.t}
              </div>
            ))}
          </div>
        </div>
        <div className="relative z-10 text-xs text-slate-400">© {new Date().getFullYear()} Medoho Health. Internal use only.</div>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8">
            <img src="/medoho-logo.png" alt="Medoho — Digital Power for Doctors" className="h-10 w-auto" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
